import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { UserContext } from "context/user";
import { updateFarm } from "api/Farm";
import CustomModal from "components/Modal";
import InputField from "components/Input";
import Button from "components/Button";
import "./index.scss";

const RenameFarm = ({ farmInfo, isOpen, onClose }) => {
  const { token } = useContext(UserContext);
  const [farmName, setFarmName] = useState("");

  const handleRenameFarm = async () => {
    try {
      const params = {
        data: {
          farm_name: farmName,
        },
      };

      await updateFarm(farmInfo.farm_id, params, token);

      toast.success("Farm name updated!");

      window.location.reload();
    } catch (e) {
      toast.error(e);
    }
  };

  const handleOnClose = () => {
    setFarmName("");
    onClose();
  };

  return (
    <CustomModal
      isOpen={isOpen}
      size="medium"
      onClose={handleOnClose}
      onRequestClose={handleOnClose}
    >
      <div className="rename-farm" data-testid="delete-modal-content">
        <h3 className="title">Rename Farm</h3>
        <div className="paragraph">What do you want to call your new farm?</div>
        <InputField
          label="New Farm Name"
          value={farmName}
          onChange={(e) => setFarmName(e.target.value)}
          placeholder={farmInfo.farm_name}
        />
        <Button
          id="rename-button"
          type="solid"
          color="green"
          label="Rename Farm"
          block
          onClick={handleRenameFarm}
        />
      </div>
    </CustomModal>
  );
};

RenameFarm.propTypes = {
  farmInfo: PropTypes.shape({
    farm_id: PropTypes.number.isRequired,
    farm_name: PropTypes.string.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RenameFarm;
